import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import routes from '../../config/settings/routes'
import { getLogger } from '../../core/debuggers'

const logger = getLogger('ProtectedByOnboarding.jsx')

const ProtectedByOnboarding = () => {
  const { profile, status } = useSelector(state => state.adminUserProfile)

  logger.debug(profile)

  const skippedThisSession =
    sessionStorage.getItem('onboarding_skipped') === 'true'

  // ⏳ Esperar a que el perfil esté listo
  if (status.fetch !== 'succeeded') {
    return null // o spinner si quieres
  }

  // ✅ Caso 1: onboarding completado → pasa siempre
  if (profile.onboardingStatus === 'completed') {
    return <Outlet />
  }

  // ⚠️ Caso 2: skipped → solo esta sesión
  if (skippedThisSession) {
    return <Outlet />
  }

  // ❌ Caso 3: todo lo demás → onboarding
  return <Navigate to={routes.onboarding} replace />
}

export default ProtectedByOnboarding
